import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Link } from 'react-router-dom';
import { Button, ButtonProps } from 'shared/mui/Buttons';

export type ReferenceButtonProps = ButtonProps;

export function ReferenceButton(props: ReferenceButtonProps): JSX.Element {
  const {
    label,
    startIcon = <ErrorOutlineIcon />,
    size = 'medium',
    variant = 'outlined',
    ...rest
  } = props;

  const translate = useTypedTranslate();

  return (
    <Button
      component={Link}
      label={label || translate('app.buttons.info')}
      size={size}
      startIcon={startIcon}
      variant={variant}
      {...rest}
    />
  );
}
